export default "__VITE_ASSET__CMuqN57E__"